import { createFileRoute, redirect } from '@tanstack/react-router';

import { connectionState, findConnection, socialConnectionsQueryOptions } from '@/features/social';

/** Opening Pinterest lands on Posts once the account is connected, on Connection until then. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/')({
  loader: async ({ context, params }) => {
    const connections = await context.queryClient
      .query({ ...socialConnectionsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined);
    const state = connectionState(
      connections ? findConnection(connections.items, 'pinterest') : undefined,
    );
    throw redirect({
      to:
        state === 'connected'
          ? '/s/$storeId/social/pinterest/posts'
          : '/s/$storeId/social/pinterest/connection',
      params,
      replace: true,
    });
  },
});
